import { css } from '@emotion/css';

export const errorContainerCss = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 24px;
  gap: 16px;
  text-align: center;

  img {
    width: 128px;
    height: 128px;
    object-fit: contain;
  }
`;
